export default __webpack_public_path__ + "static/media/menu_dash_selected.057d6e09.svg";